// extracted by mini-css-extract-plugin
export var banner = "_hq-0";
export var closeButton = "_hq-2";
export var greenCheckmark = "_hq-3";
export var hereLink = "_hq-4";
export var titleIcon = "_hq-1";